import { TaskLocation } from '@/api';
import { createContext } from 'react';

export interface TaskLocationsContextData {
    locations: TaskLocation[];
    latestLocation: TaskLocation | null;
    status: 'error' | 'success' | 'pending';
    refetch: () => void;
}

export const TaskLocationsContext = createContext<
    TaskLocationsContextData | undefined
>(undefined);
